import React from 'react';
import css from './all-classess.scss';

import {
    CLASS_NAME,
    COMPLETED_QUESTS_SUMMARY,
    ASSIGNED_QUESTS,
    COMPLETED_QUESTS,
    STANDARDS_IN_PROGRESS,
    STANDARDS_COMPLETED
} from '../skill-quests-mastery-constants';
import { SKILL_QUESTS_MASTERY } from '../../../components/report-filters/filter-constants';

import TableHeader from '../../../components/table-header/table-header';
import { getTranslationKey } from '../../../helpers/locale-helpers';

const ALL_CLASSES_SKILL_QUESTS_MASTERY_TABLE_CONFIG = {
    cols: [
        {
            id: CLASS_NAME.id,
            name: CLASS_NAME.name,
            sort: { sortAs: 'string' },
            truncate: true,
            onClick: () => null, // this is set in the AllClasses component
            classes: css['class-name']
        },
        {
            id: COMPLETED_QUESTS_SUMMARY.id,
            name: COMPLETED_QUESTS_SUMMARY.name,
            classes: css['completed-quests']
        },
        {
            id: STANDARDS_IN_PROGRESS.id,
            name: ''
        },
        {
            id: STANDARDS_COMPLETED.id,
            name: ''
        },
        {
            id: ASSIGNED_QUESTS.id,
            name: ''
        },
        {
            id: COMPLETED_QUESTS.id,
            name: ''
        }
    ],
    colGroups: [
        [
            {
                name: SKILL_QUESTS_MASTERY,
                colIds: [CLASS_NAME.id, COMPLETED_QUESTS_SUMMARY.id],
                headerTransform: () => (
                    <TableHeader
                        title={getTranslationKey(SKILL_QUESTS_MASTERY)}
                        showButton={false}
                        translate
                    />
                ),
                classes: css['dark-header']
            },
            {
                name: STANDARDS_IN_PROGRESS.name,
                colIds: [STANDARDS_IN_PROGRESS.id],
                classes: css['light-header']
            },
            {
                name: STANDARDS_COMPLETED.name,
                colIds: [STANDARDS_COMPLETED.id],
                classes: css['light-header']
            },
            {
                name: ASSIGNED_QUESTS.name,
                colIds: [ASSIGNED_QUESTS.id],
                classes: css['light-header']
            },
            {
                name: COMPLETED_QUESTS.name,
                colIds: [COMPLETED_QUESTS.id],
                classes: css['light-header']
            }
        ]
    ],
    defaultSort: CLASS_NAME.id,
    emptyDataMessage: 'No Skill Quests Mastery results found'
};

export default ALL_CLASSES_SKILL_QUESTS_MASTERY_TABLE_CONFIG;



// WEBPACK FOOTER //
// ./containers/skill-quests-mastery/all-classes/all-classes-constants.js